import { render, staticRenderFns } from "./performanceTrends.vue?vue&type=template&id=61d358db&scoped=true"
import script from "./performanceTrends.vue?vue&type=script&lang=js"
export * from "./performanceTrends.vue?vue&type=script&lang=js"
import style0 from "./performanceTrends.vue?vue&type=style&index=0&id=61d358db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d358db",
  null
  
)

export default component.exports